import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const Cabiner = ({featuredProjectsList}) => {
  const project = getProject('cabiner');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <VimeoVideo
          component={{
            posterVideo: '338863615'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            Cabiner is a Dutch startup that offers off-the-grid trekking
            experiences to sustainably designed cabins.
          </p>
          <p>
            After completing a successful crowdfunding campaign, the Cabiner
            team geared up for growth and therefore, asked Your Majesty to give
            the brand a redesign.
          </p>
        </AnimateIn>

        <Image
          className="g-row"
          component={{
            image: '/cabiner/02_YM.co_Logo.png',
            calculateRatio: '1920,1109'
          }}
        />

        <Image
          component={{
            image: '/cabiner/04_YM.co_StyleTile.png',
            calculateRatio: '1920,3826'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="minimum-lovable-identity">Minimum Lovable Identity</h2>
          <p>
            For three weeks, we dedicated an agile design team to work daily
            with the Cabiner stakeholders at our Amsterdam studio.
          </p>
          <p>
            The goal was ambitious yet straightforward: get a lot done and
            create a brand that stands out from the crowd while remaining
            subdued and non-commercial.
          </p>
        </AnimateIn>

        <Image
          component={{
            image: '/cabiner/03_YM.co_Card.png',
            caption:
              'The delivery package contained a new logotype, stationery, content direction, and a digital style guide.'
          }}
        />

        <Image
          component={{
            image: '/cabiner/05_YM.co_Map.png',
            calculateRatio: '1920,2360'
          }}
        />

        <Quote 
          className="g-row"
          component={{
            quote:
              '"We worked directly from YM’s office, partook in creative sessions \
              and gave feedback throughout the process. This allowed us to build \
              on each other’s ideas and produce great results — fast."',
            quotee: 'Sander Eljenberg — Founder, Creative Director'
          }}
        />

        <Image
          component={{
            image: '/cabiner/06_YM.co_Stationary.png',
            calculateRatio: '1920,6000'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="outcomes">Outcomes</h2>
          <ul>
            <li>Awarded <a href="https://www.red-dot.org/project/cabiner-37458" target="_blank">Red Dot Award</a> — "Best of the best" in product design</li>
            <li>Awarded <a href="https://www.commarts.com/project/30250/cabiner" target="_blank">Communication Arts</a> — Typographic Excellence 2020</li>
          </ul>
         
        </AnimateIn>
    
        <AnimateIn className="text g-row">
          <h2 id="like-what-you-see-">Like what you see?</h2>
          <p>
            Email{' '}
            <a href="mailto: hello@yourmajesty.co">
              hello@yourmajesty.co
            </a>{' '}
            to get us involved in your next branding project, or check out some
            of our other brand work below.
          </p>
          <p>
            <Link href="/work/samsung">
              <a>Samsung SmartThings</a>
            </Link>
            <br />
            <Link href="/work/bandstand-newcastle-helix">
              <a>Newcastle Helix</a>
            </Link>
            <br />
            <Link href="/work/onzeauto">
              <a>OnzeAuto.</a>
            </Link>
          </p>
           
          <p>
            Visit{' '}
            <a href="http://www.cabiner.co" target="_blank" rel="noopener">
              Cabiner
            </a>
            {' '}
            to learn more about their company, and to book your next
            off-the-grid nature experience.
          </p>
        </AnimateIn>

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: [
                  'Brand Strategy',
                  'Content Strategy',
                  'Creative Strategy',
                  'Workshop & Facilitation'
                ]
              },

              {
                title: 'Design',
                items: [
                  'Art Direction',
                  'Brand Design',
                  'Creative Direction',
                  'Illustration',
                  'UI/UX Design',
                  'Visual Design'
                ]
              },

              {
                title: 'Content',
                items: ['Copywriting', 'Photography']
              }
            ]
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default Cabiner;
